<template>
  <div id="page-wrapper" :class="popupShown ? 'popup-shown' : ''">
    <transition name="userpopup">
      <div id="popup-wrapper" v-if="popupShown">

        <template v-if="popupType === 'user'">
          <button class="btn btn-link text-white close" @click.prevent.stop="closePopup">
            <i class="fal fa-times"></i>
          </button>
          <user-form @saved="savedHandler" v-if="popupShown" @closePopup="closePopup"
                     :userObj="activeUser"></user-form>
        </template>
        <template v-if="popupType === 'vitamin'">
          <button class="btn btn-link text-white close" @click.prevent.stop="closePopup">
            <i class="fal fa-times"></i>
          </button>
          <h2>
            {{popupUser.fullname}}
            <span class="pl-3 small text-muted">{{formatDate(popupSubmission.finalized ? popupSubmission.finalized : popupSubmission.submitted)}}
          </span>
          </h2>

          <user-review @close="closePopup" :user="popupUser" :submission="popupSubmission"></user-review>
        </template>

      </div>
    </transition>
    <div id="page">
      <app-header></app-header>
      <div class="page-body">
        <app-navbar></app-navbar>
        <div class="main-page-content  ml-0">
          <div id="main-wrapper" class="layout-main-wrapper clearfix h-100">
            <div id="main" class="container-fluid h-100">
              <div class="row row-offcanvas row-offcanvas-left clearfix h-100">
                <main class="main-content col content-full-width" id="content" role="main h-100">
                  <section id="userlist-manager" class="section h-100">
                    <div class=" h-100">
                      <div class="row mb-15 h-100">
                        <div id="vitamins" class="col-md-12">

                          <nav class="tabnav tab-nav mb-0 dark">

                            <button
                              :class="(tab === 0 ? 'active' : '')"
                              type="button"
                              @click.stop.prevent="tab = (0)"
                              class="dark btn-link btn tab-link">
                              {{ $t('message.user_list') }}
                            </button>

                            <button
                              :class="(tab === 1 ? 'active' : '')"
                              type="button"
                              @click.stop.prevent="tab = (1)"
                              class="dark btn-link btn tab-link">
                              {{ $t('message.import_users') }}
                            </button>


                          </nav>
                          <div class="tab-content h-100" v-show="tab === 0">
                            <div class="col-card">

                              <h2 class="d-flex justify-content-between">
                                {{ $t('message.user_list') }}
                                <button v-if="role === 'hr'" @click.stop.prevent="createUser"
                                        class="btn button-link p-0">
                                  + {{ $t('message.add_user') }}
                                </button>
                              </h2>

                              <div class="row">
                                <div class="col-md-12 search-wrapper">
                                  <div class="form-row">
                                    <div class="col-md-12">

                                      <input id="fname"
                                             v-on:keyup="filterUsers"
                                             name="search-user"
                                             class="form-control mb-3"
                                             type="text"
                                             :placeholder="$t('message.find_a_user')"
                                             aria-label="Search User">
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="table-top-border border-bottom-grey mt-5"></div>
                              <table id="table-appointments" class=" table dataTable dataTableNoBtns table-striped">
                                <thead>
                                <tr>
                                  <th scope="col">{{ $t('message.last_name') }}</th>
                                  <th scope="col">{{ $t('message.first_name') }}</th>
                                  <th scope="col">{{ $t('message.age') }}</th>
                                  <th scope="col">{{ $t('message.team') }}</th>
                                  <th class="u-evaldate" scope="col">{{ $t('message.last_evaluation') }}</th>
                                  <th class="u-score" v-if="role === 'manager'" scope="col">{{ $t('message.score') }}
                                  </th>
                                  <th class="u-actions" scope="col"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="user in users">
                                  <user-row @showCurrentForUser="vitaminPopup" @getUser="getUser" :role="role"
                                            :user="user"></user-row>
                                </template>
                                </tbody>
                              </table>
                              <pager @setPage="setPage" :active-page="activePage" :result-count="resultCount"
                                     :results-perpage="resultsPerpage"></pager>
                            </div>
                          </div>
                          <div class="tab-content h-100" v-show="tab === 1">
                            <div class="col-card">
                              <user-import></user-import>
                            </div>
                          </div>

                          <!--                          <div v-if="role==='hr'" class="col-card h-auto">-->
                          <!--                            <team-list @openTeam="openTeam"></team-list>-->
                          <!--                          </div>-->
                        </div>
                      </div>
                    </div>
                  </section>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>

  import Header from "../Header";
  import Nav from "../Nav";
  // import axios from "../../axios-auth";
  import store from "../../store/store";
  import Userform from "./Userform";
  import Userrow from "./Userrow";
  import Pager from "../Pager";
  import {eventPath} from "../../polyfills";
  import TeamList from "../Teams/TeamList";
  import TeamForm from "../Teams/TeamForm";
  import UserReview from "../Review/UserReview"
  import UserImport from "./UserImport"

  export default {
    components: {
      UserImport,
      UserReview,
      teamList: TeamList,
      appHeader: Header,
      appNavbar: Nav,
      userForm: Userform,
      userRow: Userrow,
      pager: Pager,
      teamForm: TeamForm
    },
    created() {
      // this.clickOutsidePopup();
      this.role = store.state.viewMode
      this.getMyTeams();
      // this.getUsers();
    },
    computed: {
      offset() {
        return this.resultsPerpage * (this.activePage - 1)
      }
    },
    methods: {
      vitaminPopup(data) {
      //  console.log('vitamin popup', data);
        this.popupSubmission = data.current;
        this.popupUser = data.user;
        this.popupType = 'vitamin';
        this.popupShown = true;
      },
      openTeam(team) {
        // console.log('opening team', team);
        this.activeTeam = team;
        this.popupType = 'team';
        this.popupShown = true;
      },
      savedHandler() {
        this.getUsers();
      },
      clickOutsidePopup() {
        document.querySelector("body").addEventListener("mouseup", (e) => {
          const el = this.$el.querySelector('#popup-wrapper');

          const path = eventPath(e);
          let clickedInCalendar = false;
          path.forEach(el => {

            if (el.classList && el.classList.contains('flatpickr-calendar')) {
              clickedInCalendar = true
            }
          });

          if (path.includes(el) || clickedInCalendar) {
          } else {
            this.closePopup()
          }
        });
      },
      setPage(pagenumber) {
        let offset = this.resultsPerpage * (pagenumber - 1);
        //   console.log('changing page',[pagenumber,offset])
        this.start = offset;
        this.activePage = pagenumber
        this.getUsers(this.filter);
      },

      createUser() {
        this.activeUser = {tags: [], perks: [], children: [], role: {id: 1}};
        this.popupType = 'user';
        this.popupShown = true;
      },
      filterUsers(e) {
        this.activePage = 1
        const val = e.target.value;
        this.filter = val;
        this.start = 0;
        this.getUsers(this.filter)
      },
      getUsers(filter = null) {
        // console.log('getting users')
        let ep = '/users';
        let relation_search = '';
        let paging = '?_start=' + this.offset + '&_limit=' + this.resultsPerpage
        if (this.role === 'manager') {
          ep = '/teams/myusers'
        }

        let q = ep;
        let join = '?';
        if (this.role !== 'manager') {
          q += paging;
          join = '&'
        }
        let cq = ep + '/count';

        if (filter) {
          q += join + relation_search + 'fullname_contains=' + filter;
          cq += '?' + relation_search + 'fullname_contains=' + filter;
        }

        this.axios.get(q).then(users => users.data) //todo change to /teams/myteams
          .then(res => {
            let data = res;
            //   console.log('users',data)
            if (this.role === 'manager') {
              let results = data;
              this.resultCount = results.length;
              results = results.splice(0, this.offset);
              if (data.length > this.resultsPerpage) {
                data.length = this.resultsPerpage;
              }
            }

            data.forEach((user, ind) => {
              let teams = [];
              if (user.teams) {
                user.teams.forEach(team => {
                  teams.push(team.Title)
                })
              }
              user.team = teams.join(', ')
            });
            this.users = data;
          });

        if (this.role !== 'manager') {
          this.axios.get(cq).then(users => users.data)
            .then(res => {
              const data = res;
              this.resultCount = data;
            })
        }

      },
      getUser(id) {
        this.popupShown = true;
        this.popupType = 'user';
        this.activeUser = id
        // this.axios.get('/users/' + id).then(users => users.data)
        //   .then(res => {
        //
        //     const data = res;
        //     this.activeUser = data;
        // //   console.log('getting user',this.activeUser);
        //     this.popupShown = true;
        //   })
      },
      closePopup(reload = false) {
        if (reload) {
          this.getMyTeams()
        }
        this.popupShown = false;
      },
      getMyTeams() {

        this.getUsers();


      },

    },
    data() {
      return {
        tab: 0,
        popupSubmission: null,
        popupType: 'user',
        activeTeam: null,
        activePage: 1,
        resultCount: 0,
        resultsPerpage: 10,
        filter: null,
        role: null,
        start: 0,
        // limit: 10,
        users: [],
        popupUser: null,
        popupShown: false,
        activeUser: null,
      }
    }
  }
</script>


<style>

  @keyframes slide-in {
    from {
      top: -200%;
    }
    to {
      top: 0;
    }
  }

  @keyframes slide-out {
    from {
      top: 0;
    }
    to {
      top: -200%;
    }
  }

  .userpopup-enter {

  }

  .userpopup-enter-active {
    animation: slide-in .5s ease-out forwards;
  }

  .userpopup-leave {

  }

  .userpopup-leave-active {
    animation: slide-out .5s ease-out forwards;
  }

</style>



// WEBPACK FOOTER //
// src/components/Users/Userlist.vue